<script>
  import Crossword from "../src/Crossword.svelte";
  import puzzle1 from "./data/puzzle1.json";
  import puzzle2 from "./data/puzzle2.json";
  import puzzle3 from "./data/puzzle3.json";
  import puzzle4 from "./data/puzzle4.json";
  import puzzle5 from "./data/puzzle5.json";
  import puzzle6 from "./data/puzzle6.json";
  import puzzle7 from "./data/puzzle7.json";
  import puzzle8 from "./data/puzzle8.json";
  import puzzle9 from "./data/puzzle9.json";
  import puzzle10 from "./data/puzzle10.json";
  import puzzle11 from "./data/puzzle11.json";
  import puzzle12 from "./data/puzzle12.json";
  import puzzle13 from "./data/puzzle13.json";
  import puzzle14 from "./data/puzzle14.json";
  import puzzle15 from "./data/puzzle15.json";
  import puzzle16 from "./data/puzzle16.json";
  import puzzle17 from "./data/puzzle17.json";
  import puzzle18 from "./data/puzzle18.json";
  import puzzle19 from "./data/puzzle19.json";
  import puzzle20 from "./data/puzzle20.json";
  import puzzle21 from "./data/puzzle21.json";
  import puzzle22 from "./data/puzzle22.json";
  import puzzle23 from "./data/puzzle23.json";
  import puzzle24 from "./data/puzzle24.json";
  import puzzle25 from "./data/puzzle25.json";
  import puzzle26 from "./data/puzzle26.json";
  import puzzle27 from "./data/puzzle27.json";
  import puzzle28 from "./data/puzzle28.json";
  import puzzle29 from "./data/puzzle29.json";
  import puzzle30 from "./data/puzzle30.json";
  import puzzle31 from "./data/puzzle31.json";
  import puzzle32 from "./data/puzzle32.json";
  import puzzle33 from "./data/puzzle33.json";
  import puzzle34 from "./data/puzzle34.json";
  import puzzle35 from "./data/puzzle35.json";
  import puzzle36 from "./data/puzzle36.json";
  import puzzle37 from "./data/puzzle37.json";
  import puzzle38 from "./data/puzzle38.json";
  import puzzle39 from "./data/puzzle39.json";
  import puzzle40 from "./data/puzzle40.json";
  import puzzle41 from "./data/puzzle41.json";
  import puzzle42 from "./data/puzzle42.json";
  import puzzle43 from "./data/puzzle43.json";
  import puzzle44 from "./data/puzzle44.json";
  import puzzle45 from "./data/puzzle45.json";
  import puzzle46 from "./data/puzzle46.json";
  import puzzle47 from "./data/puzzle47.json";
  import puzzle48 from "./data/puzzle48.json";
  import puzzle49 from "./data/puzzle49.json";
  import puzzle50 from "./data/puzzle50.json";
  let revealedUSA;
  let theme;
</script>

<article>
  <div class="intro">
    <h3>TTS Indonesia - Teka Teka Silang</h3>
    <p style="font-size:16px">
TTS Indonesia adalah situs web tebak kata dengan huruf silang. Anda dapat memilih set soal dan menyelesaikan teka-teki yang seru dan mengasah otak. 
    </p>
  </div>

<div class="default">Set Soal: <a href="#default41">41</a> | <a href="#default42">42</a> | <a href="#default43">43</a> | <a href="#default44">44</a> | <a href="#default45">45</a> | <a href="#default46">46</a> | <a href="#default47">47</a> | <a href="#default48">48</a> | <a href="#default49">49</a> | <a href="#default50">50</a></div>
<div class="mobile">Set Soal: <a href="#mobile41">41</a> | <a href="#mobile42">42</a> | <a href="#mobile43">43</a> | <a href="#mobile44">44</a> | <a href="#mobile45">45</a> | <a href="#mobile46">46</a> | <a href="#mobile47">47</a> | <a href="#mobile48">48</a> | <a href="#mobile49">49</a> | <a href="#mobile50">50</a></div>

<section id="default41" class="default" style="margin:0">
  <div class="info">
    <h3><a href="#default41">Kuis #41</a></h3>
  </div>
  <Crossword data="{puzzle41}" />
</section>
<section id="mobile41" class="mobile" style="margin:0;max-width:719px;">
  <div class="info">
    <h3><a href="#mobile41">Kuis #41</a></h3>
  </div>
  <Crossword data="{puzzle41}" showKeyboard="{true}" />
</section>
<br/>

<section id="default42" class="default" style="margin:0">
  <div class="info">
    <h3><a href="#default42">Kuis #42</a></h3>
  </div>
  <Crossword data="{puzzle42}" />
</section>
<section id="mobile42" class="mobile" style="margin:0;max-width:719px;">
  <div class="info">
    <h3><a href="#mobile42">Kuis #42</a></h3>
  </div>
  <Crossword data="{puzzle42}" showKeyboard="{true}" />
</section>
<br/>

<section id="default43" class="default" style="margin:0">
  <div class="info">
    <h3><a href="#default43">Kuis #43</a></h3>
  </div>
  <Crossword data="{puzzle43}" />
</section>
<section id="mobile43" class="mobile" style="margin:0;max-width:719px;">
  <div class="info">
    <h3><a href="#mobile43">Kuis #43</a></h3>
  </div>
  <Crossword data="{puzzle43}" showKeyboard="{true}" />
</section>
<br/>

<section id="default44" class="default" style="margin:0">
  <div class="info">
    <h3><a href="#default44">Kuis #44</a></h3>
  </div>
  <Crossword data="{puzzle44}" />
</section>
<section id="mobile44" class="mobile" style="margin:0;max-width:719px;">
  <div class="info">
    <h3><a href="#mobile44">Kuis #44</a></h3>
  </div>
  <Crossword data="{puzzle44}" showKeyboard="{true}" />
</section>
<br/>

<section id="default45" class="default" style="margin:0">
  <div class="info">
    <h3><a href="#default45">Kuis #45</a></h3>
  </div>
  <Crossword data="{puzzle45}" />
</section>
<section id="mobile45" class="mobile" style="margin:0;max-width:719px;">
  <div class="info">
    <h3><a href="#mobile45">Kuis #45</a></h3>
  </div>
  <Crossword data="{puzzle45}" showKeyboard="{true}" />
</section>
<br/>

<section id="default46" class="default" style="margin:0">
  <div class="info">
    <h3><a href="#default46">Kuis #46</a></h3>
  </div>
  <Crossword data="{puzzle46}" />
</section>
<section id="mobile46" class="mobile" style="margin:0;max-width:719px;">
  <div class="info">
    <h3><a href="#mobile46">Kuis #46</a></h3>
  </div>
  <Crossword data="{puzzle46}" showKeyboard="{true}" />
</section>
<br/>

<section id="default47" class="default" style="margin:0">
  <div class="info">
    <h3><a href="#default47">Kuis #47</a></h3>
  </div>
  <Crossword data="{puzzle47}" />
</section>
<section id="mobile47" class="mobile" style="margin:0;max-width:719px;">
  <div class="info">
    <h3><a href="#mobile47">Kuis #47</a></h3>
  </div>
  <Crossword data="{puzzle47}" showKeyboard="{true}" />
</section>
<br/>

<section id="default48" class="default" style="margin:0">
  <div class="info">
    <h3><a href="#default48">Kuis #48</a></h3>
  </div>
  <Crossword data="{puzzle48}" />
</section>
<section id="mobile48" class="mobile" style="margin:0;max-width:719px;">
  <div class="info">
    <h3><a href="#mobile48">Kuis #48</a></h3>
  </div>
  <Crossword data="{puzzle48}" showKeyboard="{true}" />
</section>
<br/>

<section id="default49" class="default" style="margin:0">
  <div class="info">
    <h3><a href="#default49">Kuis #49</a></h3>
  </div>
  <Crossword data="{puzzle49}" />
</section>
<section id="mobile49" class="mobile" style="margin:0;max-width:719px;">
  <div class="info">
    <h3><a href="#mobile49">Kuis #49</a></h3>
  </div>
  <Crossword data="{puzzle49}" showKeyboard="{true}" />
</section>
<br/>

<section id="default50" class="default" style="margin:0">
  <div class="info">
    <h3><a href="#default50">Kuis #50</a></h3>
  </div>
  <Crossword data="{puzzle50}" />
</section>
<section id="mobile50" class="mobile" style="margin:0;max-width:719px;">
  <div class="info">
    <h3><a href="#mobile50">Kuis #50</a></h3>
  </div>
  <Crossword data="{puzzle50}" showKeyboard="{true}" />
</section>
<br/>

<br/><br/>
</article>

<style>
  @media only screen and (max-width: 1024px) {
    .default {
    display:none;
    }
  }
  @media not screen and (max-width: 1024px) {
    .mobile {
    display:none;
    }
  }
  article {
    max-width: 960px;
    margin: 0 auto;
    padding: 1em;
    font-family: sans-serif;
  }
  .intro {
    text-align: left;
    max-width: 760px;
    font-size: 1.5em;
  }
  section {
    max-width: 960px;
    margin: 5em 0;
  }

  .info {
    max-width: 640px;
    margin: 1em 0;
    text-align: left;
    font-size: 1.125em;
  }
  .info a {
    margin-right: 0.25em;
  }
  h1 {
    font-size: 1.5em;
  }
  h2 {
    font-size: 1.5em;
    padding-top: 1em;
  }
  p {
    margin: 1em auto;
  }

  #themes {
    padding: 1em;
  }

  #themes.dark {
    background: #1a1a1a;
    color: #fff;
  }
  code {
    font-size: 0.85em;
    background-color: #efefef;
    padding: 0 0.25em;
  }

  button {
    cursor: pointer;
  }
</style>
